// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lineTableColumns_departureRowContainer_fJPzc {
  max-width: 420px;
  min-width: 120px;
  margin: 0.5rem 0;
}

.lineTableColumns_breakContainer_hMjsX {
  display: block;
  break-inside: avoid;
}

.lineTableColumns_departureRow_H7rrc {
  font-size: 1rem;
  margin-left: 1.6rem;
  padding-top: 5px;
  padding-bottom: 5px;
  height: 35px;
  break-inside: avoid;
}

.lineTableColumns_departureColumnContainer_wJN4B {
  align-items: normal;
  min-width: 100px;
  max-width: 350px;
}

.lineTableColumns_tableContainer_xxMan {
  display: flex;
  margin-top: 1.3rem;
}

.lineTableColumns_wider_W_JJv {
  min-width: 270px;
}

.lineTableColumns_hour_oMqwt {
  font-family: GothamXNarrow-Medium;
  font-size: 15px;
  width: 1.5rem;
  margin-right: 0.5em;
  break-inside: avoid;
}

.lineTableColumns_minutesContainer_os6np {
  max-width: 400px;
  display: flex;
  flex-wrap: wrap;
  break-inside: avoid;
}

.lineTableColumns_minutes_TSwn0 {
  display: flex;
  min-width: 0.9em;
  font-family: GothamXNarrow-Book;
  font-size: 12px;
  letter-spacing: -0.02em;
  line-height: 1;
  margin-right: 0.2em;
}

.lineTableColumns_divider_vWb1l {
  border-right: 2px solid #3333338a;
}

.lineTableColumns_departureRowContainer_fJPzc > *:nth-child(even) {
  background-color: #eaeaea;
}
`, "",{"version":3,"sources":["webpack://./src/components/lineTimetable/lineTableColumns.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".departureRowContainer {\n  max-width: 420px;\n  min-width: 120px;\n  margin: 0.5rem 0;\n}\n\n.breakContainer {\n  display: block;\n  break-inside: avoid;\n}\n\n.departureRow {\n  font-size: 1rem;\n  margin-left: 1.6rem;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  height: 35px;\n  break-inside: avoid;\n}\n\n.departureColumnContainer {\n  align-items: normal;\n  min-width: 100px;\n  max-width: 350px;\n}\n\n.tableContainer {\n  display: flex;\n  margin-top: 1.3rem;\n}\n\n.wider {\n  min-width: 270px;\n}\n\n.hour {\n  font-family: GothamXNarrow-Medium;\n  font-size: 15px;\n  width: 1.5rem;\n  margin-right: 0.5em;\n  break-inside: avoid;\n}\n\n.minutesContainer {\n  max-width: 400px;\n  display: flex;\n  flex-wrap: wrap;\n  break-inside: avoid;\n}\n\n.minutes {\n  display: flex;\n  min-width: 0.9em;\n  font-family: GothamXNarrow-Book;\n  font-size: 12px;\n  letter-spacing: -0.02em;\n  line-height: 1;\n  margin-right: 0.2em;\n}\n\n.divider {\n  border-right: 2px solid #3333338a;\n}\n\n.departureRowContainer > *:nth-child(even) {\n  background-color: #eaeaea;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"departureRowContainer": `lineTableColumns_departureRowContainer_fJPzc`,
	"breakContainer": `lineTableColumns_breakContainer_hMjsX`,
	"departureRow": `lineTableColumns_departureRow_H7rrc`,
	"departureColumnContainer": `lineTableColumns_departureColumnContainer_wJN4B`,
	"tableContainer": `lineTableColumns_tableContainer_xxMan`,
	"wider": `lineTableColumns_wider_W_JJv`,
	"hour": `lineTableColumns_hour_oMqwt`,
	"minutesContainer": `lineTableColumns_minutesContainer_os6np`,
	"minutes": `lineTableColumns_minutes_TSwn0`,
	"divider": `lineTableColumns_divider_vWb1l`
};
module.exports = ___CSS_LOADER_EXPORT___;
